<template>
  <div id="kdm-payment-iframe-page" class="kdm-payment-container">
    <!-- Hata durumu -->
    <vs-alert color="danger" :title="$t('PaymentError')" :active.sync="hasError">
      <span>{{ errorMessage }}</span>
    </vs-alert>

    <!-- Ödeme Başarılı durumu -->
    <vs-alert color="success" :title="$t('PaymentSuccess')" :active.sync="isSuccess">
      <span>{{ successMessage }}</span>
    </vs-alert>

    <!-- iFrame Yükleniyor -->
    <div v-if="isLoading" class="kdm-loading">
      <vs-progress indeterminate color="primary"></vs-progress>
      <p>Ödeme ekranı yükleniyor...</p>
    </div>

    <!-- iFrame -->
    <div v-if="iframeUrl && !hasError && !isSuccess" class="kdm-iframe-wrapper">
      <iframe
        :src="iframeUrl"
        class="kdm-iframe"
        frameborder="0"
        allowfullscreen
        @load="onIframeLoad"
      ></iframe>
    </div>
  </div>
</template>

<script>
import InvoiceApi from "@/api/invoice";

export default {
  name: "KdmPaymentIframe",
  data() {
    return {
      iframeUrl: null,
      isLoading: true,
      hasError: false,
      isSuccess: false,
      errorMessage: "",
      successMessage: "",
      applicationId: null,
      pollingInterval: null,
    };
  },
  methods: {
    async initiatePayment() {
      try {
        this.$vs.loading({ color: "#000", scale: 0.45 });

        const invoiceId = this.$route.params.invoiceId;
        const result = await InvoiceApi.initiateKdmPayment(
          { invoiceId: invoiceId },
          this
        );

        if (result.data && result.data.Success) {
          this.iframeUrl = result.data.IframeUrl;
          this.applicationId = result.data.ApplicationId;

          // Ödeme durumu polling başlat
          this.startPolling();
        } else {
          this.hasError = true;
          this.errorMessage =
            (result.data && result.data.Message) || "Ödeme başlatılamadı.";
        }
      } catch (error) {
        this.hasError = true;
        this.errorMessage = "Bağlantı hatası. Lütfen tekrar deneyiniz.";
      } finally {
        this.isLoading = false;
        this.$vs.loading.close();
      }
    },

    onIframeLoad() {
      this.isLoading = false;
    },

    startPolling() {
      // Her 5 saniyede ödeme durumunu kontrol et
      this.pollingInterval = setInterval(async () => {
        await this.checkPaymentStatus();
      }, 5000);
    },

    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    async checkPaymentStatus() {
      try {
        const result = await InvoiceApi.getKdmPaymentStatus(
          this.applicationId,
          this
        );

        if (result.data && result.data.Success) {
          const state = result.data.TransactionState;

          if (state === "Approved") {
            this.stopPolling();
            this.isSuccess = true;
            this.iframeUrl = null;
            this.successMessage =
              "Ödemeniz başarıyla tamamlandı. Teşekkür ederiz.";
          } else if (state === "Error") {
            this.stopPolling();
            this.hasError = true;
            this.iframeUrl = null;
            this.errorMessage =
              (result.data && result.data.Message) || "Ödeme işlemi başarısız oldu.";
          }
          // "Approval" (pending) durumunda polling devam eder
        }
      } catch (error) {
        // Polling hatalarını sessizce yut, sonraki denemeyi bekle
      }
    },

    // postMessage ile servis sağlayıcıdan mesaj dinle
    handlePostMessage(event) {
      try {
        const data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;

        if (data.type === "PAYMENT_SUCCESS") {
          this.stopPolling();
          this.isSuccess = true;
          this.iframeUrl = null;
          this.successMessage =
            "Ödemeniz başarıyla tamamlandı. Teşekkür ederiz.";
        } else if (data.type === "PAYMENT_ERROR") {
          this.stopPolling();
          this.hasError = true;
          this.iframeUrl = null;
          this.errorMessage = data.message || "Ödeme işlemi başarısız.";
        }
      } catch (e) {
        // Diğer domain'lerden gelen mesajları yoksay
      }
    },
  },
  mounted() {
    this.initiatePayment();
    window.addEventListener("message", this.handlePostMessage);
  },
  beforeDestroy() {
    this.stopPolling();
    window.removeEventListener("message", this.handlePostMessage);
  },
};
</script>

<style scoped>
.kdm-payment-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

.kdm-loading {
  text-align: center;
  padding: 40px;
}

.kdm-loading p {
  margin-top: 16px;
  color: #666;
  font-size: 14px;
}

.kdm-iframe-wrapper {
  width: 100%;
  min-height: 600px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.kdm-iframe {
  width: 100%;
  min-height: 600px;
  border: none;
}
</style>
